import React, { useEffect, useState } from "react";
import { Modal } from "Components/ReactstrapSlim";
import OverviewVideoPlayer, { VIDEO_TITLE } from "Pages/Components/OverviewVideoPlayer";

interface OverviewVideoModalProps {
   triggerId: string;
}

const OverviewVideoModal: React.FC<OverviewVideoModalProps> = ({ triggerId }) => {
   const [isOpen, setIsOpen] = useState(false);
   const toggle = () => setIsOpen((open) => !open);

   useEffect(() => {
      const trigger = document.getElementById(triggerId);
      const open = () => setIsOpen(true);
      trigger?.addEventListener("click", open);
      return () => trigger?.removeEventListener("click", open);
   }, [triggerId]);

   return (
      <Modal
         isOpen={isOpen}
         toggle={toggle}
         centered
         className="hp3-video-modal"
         contentClassName="hp3-video-modal-content"
         backdropClassName="hp3-video-modal-backdrop"
         aria-label={VIDEO_TITLE}
      >
         <button type="button" className="hp3-video-modal-close" aria-label="Close" onClick={toggle}>
            <svg viewBox="0 0 16 16" fill="none" aria-hidden="true">
               <path d="M4 4L12 12M12 4L4 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
            </svg>
         </button>         
         <OverviewVideoPlayer />
      </Modal>
   );
};

export default OverviewVideoModal;
